(ns app.front.view.group.admin.fees.group.group-subs
  (:require [app.domain.fee.model :as fee-model]
            [app.front.entities :as entities]
            [app.front.view.group.admin.fees.template.template-events :as ft-events]
            [re-frame.core-instrumented :as rf]))


(rf/reg-sub
  ::fee-schedule-id
  (fn [db _] ; Wraps the fee schedule whose template the user is currently editing
    (-> db ::ft-events/fee-templates :fee-schedule :db/id)))


(rf/reg-sub
  ::fee-groups
  :<- [::entities/entities {:entity/type :entity.type/fee-group}]
  :<- [::fee-schedule-id]
  :<- [:language]
  (fn [[fee-groups fee-schedule-id lang] _]
    (->> (filter #(-> % :entity/parent :db/id (= fee-schedule-id)) fee-groups)
         (sort-by #(fee-model/fee-group-title % lang)))))
